<template>
  <div class="container">
    <img
      src="/assets/logo.png"
      alt="HypnoMaker logo"
      class="logo-image"
    />
    <h1 class="tagline">Create Custom Hypnosis, PMV &amp; Affirmation Videos - Fast, Effortless, Free to Start</h1>
    <a href="https://hypnomaker.itch.io/hypnomaker" class="download-btn" target="_blank" rel="noopener">Download on Itch.io</a>

    <div class="steps">
      <div class="step-card">
        <div class="step-num">1</div>
        <div class="step-name">Pick a Script</div>
        <p>Choose from 102 built-in hypno scripts with male and female voiceovers, or write your own with the built-in editor.</p>
      </div>
      <div class="step-card">
        <div class="step-num">2</div>
        <div class="step-name">Add Your Media</div>
        <p>Point at a folder or handpick and order your clips. HypnoMaker handles the cutting, captions, and beat-sync automatically.</p>
      </div>
      <div class="step-card">
        <div class="step-num">3</div>
        <div class="step-name">Export &amp; Enjoy</div>
        <p>TTS voiceover, binaural audio, source-audio mixing, overlays, and filters, all combined into a single ready-to-share MP4, single or three-panel.</p>
      </div>
    </div>

    <div class="home-links">
      <router-link to="/docs">Read the full documentation →</router-link>
    </div>
  </div>
</template>

<script setup>
// static page
</script>

<style scoped>
.logo-image {
  width: min(100%, 480px);
  height: auto;
  display: block;
  margin: 0 auto;
  padding-bottom: 28px;
}

.tagline {
  margin-top: 10px;
}

.steps {
  display: flex;
  gap: 16px;
  max-width: 900px;
  width: 100%;
  margin: 0.5rem auto 1.5rem;
}

.step-card {
  flex: 1;
  background: #fff5f8;
  border: 1.5px solid #ffd6e7;
  border-top: 4px solid #ff85b0;
  border-radius: 10px;
  padding: 18px 20px;
  text-align: left;
  transition: border-top-color 0.25s, box-shadow 0.25s;
}
.step-card:hover {
  border-top-color: #ff3d82;
  box-shadow: 0 4px 18px rgba(255, 80, 140, 0.12);
}

.step-num {
  font-family: 'Pacifico', cursive;
  font-size: 26px;
  color: #ff3d82;
  line-height: 1;
  margin-bottom: 8px;
}

.step-name {
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #ff3d82;
  margin-bottom: 6px;
}

.step-card p {
  color: #3d1a26;
  font-size: 14.5px;
  line-height: 1.55;
  margin: 0;
}

.home-links {
  margin-bottom: 1rem;
}
.home-links a {
  color: #391a67;
  font-weight: 600;
  text-decoration: underline;
  font-size: 1rem;
}
.home-links a:hover {
  color: #ff3d82;
}

@media (max-width: 700px) {
  .steps {
    flex-direction: column;
    max-width: 440px;
  }
  .logo-image {
    padding-bottom: 24px;
  }
}
</style>
